import { IDetailsListStyles, makeStyles } from "@fluentui/react";

export const useStyles = makeStyles({
    page: {
        display: "grid",
        // width: "100%",
        height: "100%",
        padding: '1rem',
        scrollbarWidth: "auto",
        gridTemplateAreas: `
            "head"
            "main"
            "foot"
        `,
        gridTemplateRows: "42px 1fr 24px",
        gridTemplateColumns: "1fr",
    },
    head: {
        gridArea: "head",
        padding: '0px'
    },
    main: {
        gridArea: "main",
        overflowX: "scroll",
        margin: "0px 0px",
    },
    footer: {
        gridArea: "foot",
        alignSelf: "center",
        paddingTop: "5px"
    }
});

export const gridStyles: Partial<IDetailsListStyles> = {
    root: {
      overflow: 'scroll',
      selectors: {
        '& [role=grid]': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          height: '70vh',
        },
      },
    },
    headerWrapper: {
      flex: '0 0 auto',
    },
    contentWrapper: {
      flex: '1 1 auto',
      overflow: 'scroll',
    },
  };